var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "input-group input-group-sm p-0 rounded-0 datepicker date"
      },
      [
        _c("input", {
          staticClass: "form-control form-control-sm",
          attrs: {
            type: "text",
            placeholder: _vm.placeholder,
            disabled: _vm.disabled
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "input-group-append" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              attrs: { disabled: _vm.disabled, type: "button" }
            },
            [
              _c("span", { class: _vm.disabled ? "invisible" : "visible" }, [
                _vm._v("...")
              ])
            ]
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }